import {
  GET_INVENTORY_VALUATION_REQUEST,
  GET_INVENTORY_VALUATION_SUCCESS,
  GET_INVENTORY_VALUATION_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getInventoryValuation = (token, data) => (dispatch) => {
  dispatch({ type: GET_INVENTORY_VALUATION_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/valuationReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      item_code: data.sku === undefined ? null : data.sku,
      location_id: data.location === undefined || data.location === "All" ? null : data.location,
      date_from: moment(data.from_date).format("MM-DD-YYYY"),
      date_to: moment(data.to_date).format("MM-DD-YYYY"),
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_INVENTORY_VALUATION_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_INVENTORY_VALUATION_ERROR,
        payload: [],
      });
    });
};